import { Component, inject } from '@angular/core';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { VwfsFrameSettingsTable } from '@/table-settings/imports/vwfs-frame-settings-table';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { VwfsFrameDataSource } from '@components/new-table/data-sources/vwfs-frame.dataSource';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { PracticesService } from '@services/practices.service';
import { VwfsFrameModel } from '@/models/imports/vwfs-frame-model';
import { LoggerService } from '@services/logger.service';

@Component({
  selector: 'app-vwfs-frame-table',
  templateUrl: './vwfs-frame-table.component.html',
  styleUrls: ['./vwfs-frame-table.component.scss'],
})
export class VwfsFrameTableComponent {
  displayedColumns: TableColumnsSetting<any>;

  dataSource = new VwfsFrameDataSource(this.importFlowService);

  toastr = inject(ToastrService);
  dialog = inject(MatDialog);
  router = inject(Router);

  reloadTrigger$ = new Subject<any>();

  constructor(
    private importFlowService: ImportFlowService,
    private practicesService: PracticesService,
  ) {
    this.displayedColumns = VwfsFrameSettingsTable.getColumnsSetting();
  }

  btnDetailsClickFunction(row: VwfsFrameModel) {
    const telaio = row.telaio;
    if (!telaio) {
      this.toastr.error('Telaio non disponibile');
      return;
    }

    this.practicesService
      .getDataForTable({
        page: 0,
        size: 1,
        telaio: telaio,
      })
      .subscribe({
        next: (response) => {
          if (response && response.content && response.content.length > 0) {
            const practiceId = response.content[0].id;
            this.router.navigate([`/practices-management/practices/details/${practiceId}`]);
          } else {
            this.toastr.warning('Nessuna pratica trovata per questo telaio');
          }
        },
        error: (error) => {
          this.toastr.error('Errore nel recupero della pratica');
          LoggerService.error('Error retrieving practice for frame', error);
        },
      });
  }
}
